import React from 'react';

/**
 * Compose multiple higher-order components into a single higher-order component.
 * The composition follows from right to left (like pipe operator).
 *
 * @param {...Function} hocs The HOCs to compose
 * @returns {Function} A composed HOC
 *
 * @example
 * // Instead of this:
 * const EnhancedComponent = withA(withB(withC(BaseComponent)));
 *
 * // You can do this:
 * const enhance = composeHOC(withA, withB, withC);
 * const EnhancedComponent = enhance(BaseComponent);
 */
export const composeHOC = (
  ...hocs: Array<
    // eslint-disable-next-line no-unused-vars
    (Component: React.ComponentType<any>) => React.ComponentType<any>
  >
) => {
  return (BaseComponent: React.ComponentType<any>) => {
    return hocs.reduceRight(
      (AccumulatedComponent, hoc) => hoc(AccumulatedComponent),
      BaseComponent
    );
  };
};
